import lessRequire from  '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import Suggest from './suggest/main';
import cn from 'classname';

import Items from './items';
import SelectedFilters from './selected-filters';

lessRequire('modules/shared/filters/main.less');

const propTypes = {
	filters: PropTypes.object,
	filterToggle: PropTypes.func,
	filterInitSelect: PropTypes.func,
	filterChooseItem: PropTypes.func,
	filterDeleteItem: PropTypes.func,
	filterSuggestItems: PropTypes.func,
	filterApply: PropTypes.func,
	filterClear: PropTypes.func,
	filterToggleChildrenHighlight: PropTypes.func,
	intl: PropTypes.func
};

const Main = props => {
	const { opened } = props.filters;
	return (
		<div className="filters-container">
			<div className={cn('filters-wrap', opened && 'opened')}>
				{ <Items {...props} /> }
				{ opened &&
				<Suggest
					filter={opened}
					onInit={props.filterInitSelect}
					onChooseItem={props.filterChooseItem}
					onDeleteItem={props.filterDeleteItem}
					onSuggestItems={props.filterSuggestItems}
					onToggle={props.filterToggle}
					onApply={props.filterApply}
					onClear={props.filterClear}
					intl={props.intl} />
				}
			</div>

			<SelectedFilters {...props} />
		</div>
	);
};

Main.propTypes = propTypes;
export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/main.js